import { Enterprise } from "../../../../domain/models/enterprise";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * EnterpriseViewer
 */

type Props = {
  enterprise: Enterprise,
  onClick?: (selectedEnterprise: Enterprise) => void,
};

export const EnterpriseViewer = ({ enterprise, onClick }: Props) => {
  return (
    <div
      key={enterprise.id}
      className="w-full border-b-[1px] border-b-border-light-gray dark:border-b-border-dark-gray 
        p-3 flex justify-between items-center cursor-pointer hover:bg-hover-light-gray rounded-[4px]
        text-black hover:text-black dark:text-white dark:hover:text-black"
      onClick={() => onClick?.(enterprise)}>
      <p>{enterprise.nome}</p>
      <div className="flex items-center gap-2">
        <p className="text-sm text-primary-green">Selecionar</p>
        <DynamicIcon nameIcon="ArrowForwardRounded" className="text-primary-green" size={25} />
      </div>
    </div>
  );
};